import AlertsConfigPage from "@/pages/AlertsConfigPage";
export default function AdminAlerts() { return <AlertsConfigPage scope="admin" path="/admin/alerts" />; }
